export const ORION_PROMO = {
  popupKey: 'orion-popup-hexomatic',
  legacyPopupKey: 'hw-orion-popup-2026-10',
  headline: 'Introducing OR:ON, a new product from the Hexact team',
  text:
    'OR:ON is a separate AI-first monitoring app with its own plans. Tell it what to watch in plain words, and it explains every change. Sign in with your Hexact account and start free.',
  cta: 'Try OR:ON free',
  link: 'https://orion.hexowatch.com/',
  source: 'hexomatic-dashboard',
};

export const getOrionLink = (medium: 'hellobar' | 'popup'): string =>
  `${ORION_PROMO.link}?utm_source=${ORION_PROMO.source}&utm_medium=${medium}`;
